'use strict';

import React from 'react';
import { Input, Form, Row, Col, Button, Tree, Select, Checkbox, Card } from 'antd';
import { textOnChange, selectOnChange, checkOnChange, getSCModal } from 'rt-sd-dnd/sgiDndDev/Dnd_SgiFormEditorCommon';
import {
    formItemLayout, formItemLayout2, ctlTypes, valueTypes,
    getTextEidtor, getNumberEidtor, getValidForm, getTimeEidtor,
    getDateEidtor, getComboxEidtor, getCheckboxGroupEidtor, getCheckboxEidtor,
    getComboxTreeEidtor, getEidtorFun
} from './Constant';
import { PrmFactory } from 'rt-sd-common/sgiFactory/PrmFactory';
const FormItem = Form.Item;
const TreeNode = Tree.TreeNode;
const Option = Select.Option;
import { uuid } from 'rt-sd-common/sgiCommon/sgiCommon';
import { renderTreeNodes } from './common'

const testStyle = {
    padding: 5,
};

function copyObj(target, source) {
    if (Array.isArray(source)) {
        target = target || [];
        source.forEach(sou => {
            if (!target.some(tar => {
                if (tar.nodeType === "group") {
                    const scFlg = (tar.sc === sou.sc);
                    const sameFlg = scFlg || (tar.cldSet && sou.cldSet && tar.cldSet[0] && sou.cldSet[0] && tar.cldSet[0].id === sou.cldSet[0].id);
                    if (sameFlg) {
                        copyObj(tar, sou);
                        return true;
                    }
                } else {
                    if (tar.id === sou.id) {
                        copyObj(tar, sou);
                        return true;
                    }
                }
            })) {
                target.push(sou);
            };
        });
    } else {
        source = source || {};
        for (const sKey in source) {
            if (typeof source[sKey] === "object") {
                if (!target[sKey]) {
                    target[sKey] = source[sKey];
                } else {
                    copyObj(target[sKey], source[sKey]);
                }
            } else {
                target[sKey] = source[sKey];
            }
        }
    }
    return target;
}

class CustAdvanceQuery extends React.Component {
    constructor(props) {
        super(props);

        let treeData = [];
        let guid;
        let prm;
        // let guids = guid.split("_");
        // let prm = PrmFactory.getPrm(guid);
        let _key = uuid(8);
        var detail = tool.parseForBrowserHistory(this.props) || { record: {} };
        if (!detail.addFlag) {
            guid = detail.record.guid;
            prm = detail.record;
            _key = detail.record[_key] || _key;
        }
        if (!prm) prm = {};

        // 查询特征标签参数
        let custTag = PrmFactory.getPrm("param_param_custTag_0001");
        if (!custTag) {
            tool.sgiLogger.error("特征标签[param_param_custTag_0001]参数不存在");
        } else {
            prm = copyObj(custTag, prm);
            tool.sgiLogger.info('prm :', prm);
        }

        treeData.push(prm);

        this.state = {
            values: prm,
            selectedKeys: [_key],
            treeData: treeData,
            sysStore: [],
            nodeType: "prm",//节点类型
            SCModalVisible: false,
            checkedKeys: [],
        };
    }

    addSub = (nodeType) => {
        let record = this.state.values;
        if (!record) {
            alert("请选择节点");
        }
        this.addCldSet(record, nodeType);
    }
    save = () => {
        let prm = this.state.treeData[0];
        tool.sgiLogger.info("save prm:", prm);
        let result = PrmFactory.save(prm);
        if (result == 0) {
            alert("保存成功");
        } else {
            alert("保存失败，result：" + result);
        }
    }
    refresh(attname, value) {
        this.state.values[attname] = value;
        this.setState({ loading: false });
    }

    renderSelectOptions(data) {
        return data.map((item) => {
            return <Option value={item.c}>{item.te}</Option>;
        });
    }

    getCtlProps() {
        return getEidtorFun(this, this.state.values.desId);
    }

    onSelect = (selectedKeys, info) => {
        this.setState({ selectedKeys });
        let record = info.node.props.dataRef;
        this.setState({ values: record });
        let nodeType = info.node.props.dataRef.nodeType;
        this.setState({ nodeType });
    }

    addCldSet = (record, nodeType) => {
        let cldSet = record.cldSet;
        if (!cldSet) {
            cldSet = record.cldSet = [];
        }
        let item = {
            te: "xxx",
            _key: uuid(8),
            nodeType: nodeType,
        };
        if (nodeType == "tag") {
            item.id = uuid(64);
            item.desId = "EP_EO_UI_3101";//默认文本框
        }
        cldSet.push(item);
        this.setState({ loading: false });
    }

    fitSysCombox() {

        // 下拉窗列表值在标准代码中的id
        var comboBoxData = StandardCode.getSC("param_SC_param_0001");
        if (!comboBoxData) {
            return;
        }

        let attKey = 'c', attName = 'te';

        this.state.sysStore = [];

        var size = comboBoxData.length;
        if (!size == 0) {
            for (let i = 0; i < size; i++) {
                var item = comboBoxData[i];
                this.state.sysStore.push(<Option value={item[attKey]}>{item[attName]}</Option>);
            }
        }
    }

    getShowCard = () => {

        this.fitSysCombox();

        switch (this.state.nodeType) {
            case "prm":
                return (
                    <Card size="small" title="参数定义" style={{ marginLeft: "5px" }}>
                        <div style={testStyle} >
                            <Form>
                                {/* <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"应用编码"}>
                                            <Input disabled={true} value={this.state.values.ap} />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"系统代码"}>
                                            <Input disabled={true} value={this.state.values.tt} />
                                        </FormItem>
                                    </Col>
                                </Row> */}
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"子系统编码"}>
                                            <Select disabled value={this.state.values.ss} onChange={selectOnChange.bind(this, this, 'ss')}>{this.state.sysStore}</Select>
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"语义码"}>
                                            <Input disabled value={this.state.values.sc} onChange={textOnChange.bind(this, this, 'sc')} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"名称"}>
                                            <Input value={this.state.values.n} onChange={textOnChange.bind(this, this, 'n')} />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"显示名称"}>
                                            <Input value={this.state.values.te} onChange={textOnChange.bind(this, this, 'te')} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"创建人"}>
                                            <Input disabled={true} value={this.state.values.auth} />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"创建时间"}>
                                            <Input disabled={true} value={this.state.values.crtTm} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"修改人"}>
                                            <Input disabled={true} value={this.state.values.edAuth} />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"修改时间"}>
                                            <Input disabled={true} value={this.state.values.edTm} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"参数版本"}>
                                            <Input disabled={true} value={this.state.values.prmVsn} />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"GUID"}>
                                            <Input disabled={true} value={this.state.values.guid} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={16}>
                                        <FormItem {...formItemLayout2} style={{ margin: "1px 0px" }} label={"注释"}>
                                            <Input.TextArea value={this.state.values.ann} onChange={textOnChange.bind(this, this, 'ann')} />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Card>
                );
            case "group":
                return (
                    <Card size="small" title="分组定义" style={{ marginLeft: "5px" }}>
                        <div style={testStyle} >
                            <Form>
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"组名"}>
                                            <Input value={this.state.values.te} onChange={textOnChange.bind(this, this, 'te')} />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"编码"}>
                                            <Input disabled={true} value={this.state.values.sc ? this.state.values.sc : (this.state.values.sc = tool.uuid(8))} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={16}>
                                        <FormItem {...formItemLayout2} style={{ margin: "1px 0px" }} label={"描述"}>
                                            <Input.TextArea value={this.state.values.ann} onChange={textOnChange.bind(this, this, 'ann')} />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Card>
                );
            default:
                let desId = this.state.values.desId;
                if (!desId) desId = this.state.values.desId = "EP_EO_UI_3101";
                return (
                    <Card size="small" title="属性定义" style={{ marginLeft: "5px" }}>
                        <div style={{ ...testStyle, display: this.state.display }} >
                            <Form>
                                <Row>
                                    <Col span={16}>
                                        <FormItem {...formItemLayout2} style={{ margin: "1px 0px" }} label={"标签ID"}>
                                            <Input disabled={true} value={this.state.values.id} />
                                        </FormItem>
                                    </Col>
                                    <Col span={3}>
                                        <FormItem labelCol={{ span: 18 }} style={{ margin: "1px 0px" }} label={"允许为空"}>
                                            <Checkbox checked={this.state.values.alwBlk} onChange={checkOnChange.bind(this, this, 'alwBlk')} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"名称"}>
                                            <Input value={this.state.values.te} onChange={textOnChange.bind(this, this, 'te')} />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"编码"}>
                                            <Input value={this.state.values.c} onChange={textOnChange.bind(this, this, 'c')} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={16}>
                                        <FormItem {...formItemLayout2} style={{ margin: "1px 0px" }} label={"描述"}>
                                            <Input value={this.state.values.ann} onChange={textOnChange.bind(this, this, 'ann')} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"组件类型"}>
                                            <Select
                                                value={desId}
                                                onChange={selectOnChange.bind(this, this, "desId")}>
                                                {this.renderSelectOptions(ctlTypes)}
                                            </Select>
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} style={{ margin: "1px 0px" }} label={"值类型"}>
                                            <Select
                                                value={this.state.values.valueType || "01"}
                                                onChange={selectOnChange.bind(this, this, "valueType")}>
                                                {this.renderSelectOptions(valueTypes)}
                                            </Select>
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                        <div style={testStyle}>
                            {this.getCtlProps()}
                        </div>
                    </Card>
                );
        }

    }

    onCheck = (checkedKeys, e) => {
        tool.sgiLogger.info('e :', e);
        let { checked, checkedNodes, node, event } = e;
        this.checkData(node.props.dataRef, checked);
        // if (!checked) {
        //     // 取消勾选，要将父节点置为false
        //     const pos = node.props.pos;
        //     const poss = pos.split("-");
        //     let parentData = this.state.treeData[parseInt(poss[1])]
        // }
        this.setState({ checkedKeys });
    }

    // 递归赋值checked
    checkData(data, checked) {
        if (data.cldSet) {
            data.cldSet.forEach(cld => {
                this.checkData(cld, checked);
            });
            delete data._checked;
        } else {
            data._checked = checked;
        }
    }

    renderTreeNodes = (data) => {
        return data.map((item) => {
            item._key = item._key || tool.uuid();
            if (item._checked) this.state.checkedKeys.push(item._key);
            if (item.cldSet) {
                return (
                    <TreeNode title={item.te} key={item._key} dataRef={item}>
                        {this.renderTreeNodes(item.cldSet)}
                    </TreeNode>
                );
            }
            return <TreeNode title={item.te} key={item._key} dataRef={item} />;
        });
    }

    render() {

        return (
            <div style={{ height: '99%', width: '99%', padding: 5 }}>
                <Row style={{ margin: '5px 0px 5px 0px', height: "100%" }}>
                    <Col span={5} style={{ height: "100%" }}>
                        <div style={{ height: "100%", overflow: "auto" }}>
                            <Tree
                                draggable
                                checkable
                                defaultExpandAll
                                onSelect={this.onSelect}
                                selectedKeys={this.state.selectedKeys}
                                onCheck={this.onCheck}
                                checkedKeys={this.state.checkedKeys}
                            >
                                {this.renderTreeNodes(this.state.treeData)}
                            </Tree>
                        </div>
                    </Col>
                    <Col span={19}>
                        <div style={testStyle}>
                            <Button type="primary" onClick={this.save} style={{ margin: 5 }} >保存</Button>
                            {/* <Button type="primary" onClick={this.addSub.bind(this, "group")} style={{ margin: "5px 5px 5px 0" }} >添加分组</Button>
                            <Button type="primary" onClick={this.addSub.bind(this, "tag")} style={{ margin: "5px 5px 5px 0" }} >添加指标</Button> */}
                        </div>
                        {this.getShowCard()}
                    </Col>
                </Row>
                {getSCModal(this)}
            </div >
        )
    }

}

export default CustAdvanceQuery;



// WEBPACK FOOTER //
// ./apps/pages/paramMng/CustAdvanceQuery.js